import s from './style.css';
import Container from 'components/Container';

const RelatedContent = ({ title, related }) => (
	<div className={s.root}>
		<Container>
			<h2 className={s.title}>{title}</h2>
			<div className={s.related}>
				{related.map(({ name, desc, image, url }) => (
					<a
						href={url}
						target={'_blank'}
						rel="noopener noreferrer"
						className={s.article}
					>
						<span
							className={s.image}
							style={{
								backgroundImage: `url(${image})`
							}}
						/>
						<h3 className={s.name}>
							<span>{name}</span>
						</h3>
						<p classNAme={s.desc}>{desc}</p>
					</a>
				))}
			</div>
		</Container>
	</div>
);

export default RelatedContent;



// WEBPACK FOOTER //
// ./components/RelatedContent/index.js